import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class NoteService {
    constructor(private http: HttpClient) { }

    listByItem(id: number): Promise<any[]> {
        return new Promise((resolve, reject) => {
            this.http.get(`/api/items/${id}/notes`).subscribe(
                (notes: any[]) => resolve(notes),
                (error) => reject(error)
            );
        });
    }
}
